import _ from 'lodash';
import CHATED from '../../../helpers/chated-client';
import {
	GET_ABANDONED_CART_TEMPLATE_CONNECTION,
	GET_ABANDONED_CART_TEMPLATE_CONNECTIONS,
	ERROR_GET_ABANDONED_CART_TEMPLATE_CONNECTION,
	UPDATE_TEMPLATE_CONNECTION_BY_ID,
	UPDATE_TEMPLATE_CONNECTIONS,
	ERROR_UPDATE_TEMPLATE_CONNECTION_BY_ID,
	UPDATE_SAMPLE_EMAIL_RECIPIENT_EMAIL,
	SEND_SAMPLE_EMAIL,
	RENDER_ABANDONED_CART_EMAIL_TEMPLATE,
	ERROR_RENDER_ABANDONED_CART_EMAIL_TEMPLATE,
	ERROR_GET_IN_PROGRESS_PAYMENTS,

	RESET_ALERT_MESSAGE,
	RESET,

	UPDATE_FORM_FIELD,
	UPDATE_FORM_FIELD_FOR_GENERAL_SETTINGS_PAGE,
	GET_IN_PROGRESS_PAYMENTS
} from '../../../constants';

export function resetAlertMessage() {
	return async (dispatch) => {
		dispatch({
			type: RESET_ALERT_MESSAGE
		});
	};
}

export function reset() {
	return async (dispatch) => {
		dispatch({
			type: RESET
		});
	};
}

export function getInProgressPayments() {
	return async (dispatch) => {
		const response = await CHATED.payment.getAll({
			in_progress: true
		});

		if (response.meta.code !== 200) {
			dispatch({
				type: ERROR_GET_IN_PROGRESS_PAYMENTS,
				meta: response.meta
			});
			return;
		}

		dispatch({
			type: GET_IN_PROGRESS_PAYMENTS,
			payments: response.data.payments
		});
	};
}

export function updateFormFieldForGeneralSettingsPage(templateSlug, templateConnectionFirstEmail, templateConnectionSecondEmail, templateConnectionThirdEmail, fieldName, fieldValue) {
	return async (dispatch) => {
		switch (templateSlug) {
			case 'abandoned_cart':
				_.set(templateConnectionFirstEmail, fieldName, fieldValue);
				break;
			case 'abandoned_cart_second_email':
				_.set(templateConnectionSecondEmail, fieldName, fieldValue);
				break;
			case 'abandoned_cart_third_email':
				_.set(templateConnectionThirdEmail, fieldName, fieldValue);
				break;
			default:
		}
		dispatch({
			type: UPDATE_FORM_FIELD_FOR_GENERAL_SETTINGS_PAGE,
			templateConnectionFirstEmail: _.cloneDeep(templateConnectionFirstEmail),
			templateConnectionSecondEmail: _.cloneDeep(templateConnectionSecondEmail),
			templateConnectionThirdEmail: _.cloneDeep(templateConnectionThirdEmail)
		});
	};
}

export function updateFormField(templateConnection, fieldName, fieldValue) {
	return async (dispatch) => {
		_.set(templateConnection, fieldName, fieldValue);

		dispatch({
			type: UPDATE_FORM_FIELD,
			templateConnection: _.cloneDeep(templateConnection)
		});
	};
}

export function updateSampleEmailRecipientEmail(sampleEmailRecipientEmail) {
	return async (dispatch) => {
		dispatch({
			type: UPDATE_SAMPLE_EMAIL_RECIPIENT_EMAIL,
			sampleEmailRecipientEmail
		});
	};
}

export function getAbandonedCartTemplateConnections(page, limit) {
	return async (dispatch) => {
		const response = await CHATED.templateConnection.getAll();

		if (response.meta.code !== 200) {
			dispatch({
				type: ERROR_GET_ABANDONED_CART_TEMPLATE_CONNECTION,
				meta: response.meta
			});
			return;
		}

		const templateConnectionFirstEmail = _.find(response.data.template_connections, o => o.template_slug === 'abandoned_cart');
		const templateConnectionSecondEmail = _.find(response.data.template_connections, o => o.template_slug === 'abandoned_cart_second_email');
		const templateConnectionThirdEmail = _.find(response.data.template_connections, o => o.template_slug === 'abandoned_cart_third_email');

		if (!_.isNil(templateConnectionFirstEmail) && !_.isNil(templateConnectionSecondEmail) && !_.isNil(templateConnectionThirdEmail)) {
			dispatch({
				type: GET_ABANDONED_CART_TEMPLATE_CONNECTIONS,
				meta: null,
				templateConnectionFirstEmail,
				templateConnectionSecondEmail,
				templateConnectionThirdEmail
			});
		} else {
			dispatch({
				type: ERROR_GET_ABANDONED_CART_TEMPLATE_CONNECTION,
				meta: response.meta
			});
		}
	};
}

export function updateTemplateConnections(templateConnections) {
	return async (dispatch) => {
		const response = await CHATED.templateConnection.updateBatch(templateConnections);

		if (response.meta.code === 200) {
			const templateConnectionFirstEmail = _.find(response.data.template_connections, o => o.template_slug === 'abandoned_cart');
			const templateConnectionSecondEmail = _.find(response.data.template_connections, o => o.template_slug === 'abandoned_cart_second_email');
			const templateConnectionThirdEmail = _.find(response.data.template_connections, o => o.template_slug === 'abandoned_cart_third_email');

			dispatch({
				type: UPDATE_TEMPLATE_CONNECTIONS,
				meta: response.meta,
				templateConnectionFirstEmail,
				templateConnectionSecondEmail,
				templateConnectionThirdEmail
			});
		} else {
			dispatch({
				type: ERROR_UPDATE_TEMPLATE_CONNECTION_BY_ID,
				meta: response.meta
			});
		}
	};
}

export function getAbandonedCartTemplateConnection(templateSlug) {
	return async (dispatch) => {
		const response = await CHATED.templateConnection.getAll(); // TODO - specify for email 1,2, or 3

		if (response.meta.code !== 200) {
			dispatch({
				type: ERROR_GET_ABANDONED_CART_TEMPLATE_CONNECTION,
				meta: response.meta
			});

			return;
		}

		const templateConnection = _.find(response.data.template_connections, {
			template_slug: templateSlug
		});

		if (!_.isNil(templateConnection)) {
			dispatch({
				type: GET_ABANDONED_CART_TEMPLATE_CONNECTION,
				meta: null,
				templateConnection
			});
		} else {
			dispatch({
				type: ERROR_GET_ABANDONED_CART_TEMPLATE_CONNECTION,
				meta: response.meta
			});
		}
	};
}

export function updateTemplateConnectionById(id, templateConnection) {
	return async (dispatch) => {
		const response = await CHATED.templateConnection.update(id, templateConnection);

		if (response.meta.code === 200) {
			const templateConnection = response.data.template_connection;

			dispatch({
				type: UPDATE_TEMPLATE_CONNECTION_BY_ID,
				meta: response.meta,
				templateConnection
			});
		} else {
			dispatch({
				type: ERROR_UPDATE_TEMPLATE_CONNECTION_BY_ID,
				meta: response.meta
			});
		}
	};
}

export function renderAbandonedCartEmailTemplate(templateSettings) {
	return async (dispatch) => {
		const body = {
			settings: {...templateSettings}
		};
		const response = await CHATED.emailTemplate.renderAbandonedCart(body);

		if (response.meta.code === 200) {
			const html = response.data.html;

			dispatch({
				type: RENDER_ABANDONED_CART_EMAIL_TEMPLATE,
				meta: response.meta,
				html
			});
		} else {
			dispatch({
				type: ERROR_RENDER_ABANDONED_CART_EMAIL_TEMPLATE,
				meta: response.meta
			});
		}
	};
}

export function sendSampleEmail(recipientEmail) {
	return async (dispatch) => {
		const response = await CHATED.setting.sendSampleEmail({
			recipient_email: recipientEmail
		});

		if (response.meta.code === 200) {
			dispatch({
				type: SEND_SAMPLE_EMAIL,
				meta: response.meta
			});
		} else {
			dispatch({
				type: ERROR_UPDATE_TEMPLATE_CONNECTION_BY_ID,
				meta: response.meta
			});
		}
	};
}



// WEBPACK FOOTER //
// ./src/containers/dashboard-emails-settings-page/actions/index.js